import React from "react";
import '../../App.css';
import Footer from "../../components/Footer";

function Income() {
    return  (
        <div >
        <h3>welcome to Income page</h3>
        <Footer/>
        </div>
    
    )
    
    
}

export default Income;